import React from 'react';

import { adminEntityTypeForKey } from './admin-entity-type-by-key';
import { AdminObjectBadge } from './admin-object-badge.component';

export interface AdminObjectBadgeMapperProps {
    id: string;
    /** Field key (e.g. `spot_id`, `user_id`) — same as ObjectBadgeMapper / PlatformObjectBadgeMapper. */
    type: string;
    className?: string;
    disableClick?: boolean;
    clearable?: {
        onClear: () => void;
    };
}

/**
 * Admin counterpart of ObjectBadgeMapper: maps a field key to AdminObjectBadge.
 * Entity types without an admin detail path render display-only (decided inside AdminObjectBadge
 * once the entity is resolved via BadgeUtils.navigateString).
 */
export const AdminObjectBadgeMapper = (props: AdminObjectBadgeMapperProps) => {
    const entityType = adminEntityTypeForKey(props.type);
    if (!entityType) {
        return null;
    }

    return (
        <AdminObjectBadge
            id={props.id}
            entityType={entityType}
            className={props.className}
            disableClick={props.disableClick}
            clearable={props.clearable}
        />
    );
};
